import { DROPDOWN_ITEM_DEFAULT_HEIGHT, DROPDOWN_PADDING_Y } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useMemo } from 'react';
import { DEFAULT_APP_SORT_FIELD, DEFAULT_APP_SORT_ORDER } from '../constants/sortConstants';
import { getAppSortOptionValue, getAppSortOptions, parseAppSortOptionValue } from '../utils/sortUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const MENU_ITEM_HEIGHT = parseInt(DROPDOWN_ITEM_DEFAULT_HEIGHT, 10);
const MENU_PADDING_Y = parseInt(DROPDOWN_PADDING_Y, 10);
const SortSelectItem = ({
  children,
  option
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    delay: 200,
    disabled: !option.tooltip,
    placement: "left",
    title: option.tooltip,
    children: children
  });
};
export function AppSortDropdown({
  disabled,
  filters,
  onShowPreferredLanguageFirstChange,
  onSortChange
}) {
  const {
    showPreferredLangFirst,
    sortField,
    sortOrder
  } = filters;
  const handleChange = event => {
    const eventValue = event.target.value;
    const {
      sortField: field,
      sortOrder: order
    } = parseAppSortOptionValue(eventValue);
    onSortChange(field, order);
  };
  const value = useMemo(() => {
    return getAppSortOptionValue(sortField || DEFAULT_APP_SORT_FIELD, sortOrder || DEFAULT_APP_SORT_ORDER);
  }, [sortField, sortOrder]);
  const options = getAppSortOptions();
  const totalOptions = options.length;
  const minHeight = totalOptions * MENU_ITEM_HEIGHT + MENU_PADDING_Y * 2;
  const language = getLang();
  const showPreferredLangToggle = useMemo(() => /*#__PURE__*/_jsx(UICheckbox, {
    checked: showPreferredLangFirst,
    className: "m-top-1",
    onChange: ({
      target: {
        checked
      }
    }) => {
      if (onShowPreferredLanguageFirstChange) {
        onShowPreferredLanguageFirstChange(checked);
      }
    },
    size: "small",
    style: {
      maxWidth: 200
    },
    children: /*#__PURE__*/_jsx("span", {
      style: {
        lineHeight: '24px',
        position: 'relative',
        top: -3
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'marketplace-ui-apps-core.results.sort.showPreferredLangFirst',
        options: {
          language: unescapedText(`SharedI18nStrings.languageNames.${language}`)
        }
      })
    })
  }), [language, onShowPreferredLanguageFirstChange, showPreferredLangFirst]);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    className: "m-right-0",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'marketplace-ui-apps-core.results.sort.label'
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "apps-sort-dropdown",
      buttonUse: "transparent",
      className: "p-right-0",
      disabled: disabled,
      dropdownFooter: onShowPreferredLanguageFirstChange ? showPreferredLangToggle : null,
      itemComponent: SortSelectItem,
      menuStyle: {
        minHeight
      },
      menuWidth: "auto",
      onChange: handleChange,
      options: options,
      value: value
    })
  });
}